import type { IconData } from '@stacksjs/iconify-core'

export const arrowUpLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7 18a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H8v9a1 1 0 0 1-1 1\"/><path fill=\"currentColor\" d=\"M17 18a1 1 0 0 1-.707-.293l-10-10a1 1 0 0 1 1.414-1.414l10 10A1 1 0 0 1 17 18\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowUpLeft
